import { useTermsPrivacyAndSecurityArticles } from "@faire/help-center-utils/hooks/article/useTermsPrivacyAndSecurityArticles";
import { Weight } from "@faire/web--source/slate/Font/utils";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Link as RouterLink } from "@faire/web--source/ui/LinkAnchor";
import articlePage from "@faire/web-api--source/routes/support/articles/articleId";
import * as React from "react";
import styled from "styled-components";

import { NAVIGATION_FROM } from "../eventEnum";

interface IProps {
  navigatedFrom: NAVIGATION_FROM;
}

export const TermsList: React.FC<IProps> = ({ navigatedFrom }) => {
  const articles = useTermsPrivacyAndSecurityArticles();
  return (
    <>
      {articles?.map((article) => {
        return (
          <React.Fragment key={article.id}>
            <Link
              to={{
                pathname: articlePage(`${article.id}`),
                state: {
                  navigatedFrom,
                  pageFrom: location.pathname,
                  articleTitle: article.name,
                },
              }}
            >
              <Typography>{article.name}</Typography>
            </Link>
            <Spacer height="2x" />
          </React.Fragment>
        );
      })}
    </>
  );
};

const Link = styled(RouterLink)`
  &:hover {
    font-weight: ${Weight.medium};
  }
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
`;
